module.exports = __webpack_public_path__ + "static/media/8 UCLA winning team.c983716e.jpg";